import { Box } from "@mui/material";
import { TitleSection } from "../../components/TitleSection";
import { VerticalSlider } from "../../components/sliderPage/verticalSlider";

export const SecExperience = ({
  type,
  items,
}: {
  type: "education" | "experience";
  items: any;
}) => {
  return (
    <>
      <VerticalSlider />
      <Box
        id={type}
        sx={{
          display: "flex",
          flexDirection: "column",
          paddingX: {
            xs: "25px",
            sm: "50px",
            md: "70px",
          },
        }}
      >
        <Box sx={{ mb: "20px" }}>
          <TitleSection title={type} value={80} />
        </Box>
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
          {items?.map((item: any, inx: number) => {
            const par = inx % 2 > 0;
            return (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: {
                    xs: "row",
                    sm: "row",
                    md: par ? "row-reverse" : "row",
                  },
                }}
              >
                <Box
                  sx={{
                    display: {
                      xs: "none",
                      sm: "none",
                      md: "flex",
                    },
                    flex: 1,
                  }}
                ></Box>
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    position: "relative",
                    justifyContent: "center",
                    borderLeft: {
                      xs: `3px solid var(--c-main-color)`,
                      md: !par ? `3px solid var(--c-main-color)` : "0px",
                    },

                    borderRight: {
                      xs: undefined,
                      md: par ? `3px solid var(--c-main-color)` : "0px",
                    },
                  }}
                >
                  <Box
                    component="img"
                    alt="The house from the offer."
                    src="/img/ExperienceIcon.svg"
                    sx={{
                      padding: 1,
                      border: "2px solid var(--c-bg-content-color)",
                      position: "absolute",
                      left: (theme) => ({
                        [theme.breakpoints.down("md")]: {
                          left: "0px",
                        },
                        left: `${par ? undefined : "0px"}`,
                      }),
                      right: {
                        md: `${!par ? undefined : "0px"}`,
                      },
                      height: {
                        xs: "40px",
                        sm: "50px",
                        md: "60px",
                      },
                      width: {
                        xs: "40px",
                        sm: "50px",
                        md: "60px",
                      },
                      top: "50%",
                      transform: {
                        xs: `translate(-51.5%,-50%)`,
                        md: `translate(${par ? "51.5%" : "-51.5%"}, -50%)`,
                      },
                     color: "var(--c-text-color)",
                      zIndex: 9999,
                      backgroundColor: "var(--c-main-color-hover)",
                      boxShadow: "var(--c-box-shadow-outser-btn-1)",
                      borderRadius: 10,
                      backdropFilter: "blur(10px)",

                      "&:hover": {
                        backgroundColor: "var(--c-main-color)",
                        boxShadow:
                          "var(--c-box-shadow-outser-btn-hover) var(--c-main-color)",
                      },
                    }}
                  />
                  <Box
                    sx={{
                      borderRadius: 2,
                      backgroundColor: "var(--c-bg-content-color)",
                      border: "2px solid var(--c-bg-content-color)",
                      width: {
                        xs: "50%",
                      },
                      minWidth: {
                        xs: "75%",
                      },
                     color: "var(--c-text-color)",
                      p: 2,
                      m: 2,
                      boxShadow: "var(--c-box-shadow-outser-btn-1)",
                      "&:hover": {
                        boxShadow: "var(--c-box-shadow-outser-btn-2)",
                      },
                    }}
                  >
                    <Box sx={{ py: 0.5, fontSize: "18px", fontWeight: "bold" }}>
                      {item?.title}
                    </Box>
                    <Box sx={{ py: 0.5, fontSize: "16px", fontWeight: 300 }}>
                      {item?.range}
                    </Box>
                    <Box sx={{ py: 0.5, fontSize: "15px", fontWeight: 500,color: "gray", }}>
                      {item?.desc}
                    </Box>
                  </Box>
                </Box>
              </Box>
            );
          })}
          <Box></Box>
          <Box></Box>
        </Box>
      </Box>
    </>
  );
};
